module.exports = __webpack_public_path__ + "img/gc1-min.jpg";